export function isPremiumFromUserInfo() {
  return false;
}

const PurchaseManager = {
  isIapAvailable() {
    return false;
  },
  async getPremiumStatus() {
    return { isPremium: false };
  },
  async purchaseSubscription() {
    return { success: false, error: "web_stub" };
  },
  async restorePurchases() {
    return { success: false, error: "web_stub" };
  },
  getFeedbackSpec() {
    return { silent: true, severity: "info" };
  },
  async completePendingIapBackendSync() {
    return { success: true, silent: true };
  },
  hasPendingIapBackendSync() {
    return false;
  },
  async completePendingCreditBackendSync() {
    return { success: true };
  },
};

export default PurchaseManager;
